<template>
  <article class="articleSmallCard">
    <img :src="data.image" alt="" width="420" height="320" loading="lazy">
    <header>
      <time :datetime="machineDateFormat(this.data.date_created)">{{ dateFormat(this.data.date_created) }}</time>
      <h2 class="h4">{{ data.title }}</h2>
      <a :href="`/blog/${data.url}`" :title="translation('article_small_card-more')"></a>
    </header>
  </article>
</template>

<script>
import codeBooksMixin from "@/mixins/codeBooksMixin";
import formatMixins from "@/mixins/formatMixins";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mixins: [codeBooksMixin, formatMixins],
}
</script>